// // import logo from './logo.svg';
// import './App.css';
// import React from 'react';
// // ★★★ 변경된 임포트 부분 ★★★
// import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// import Home from './pages/Home';
// import ProfilePage from './pages/ProfilePage';
// import ChatPage from './pages/ChatPage';
// import MatchingPage from './pages/MatchingPage';

// // ★★★ 라우터 객체 정의 ★★★
// const router = createBrowserRouter([
//   {
//     path: '/',
//     element: <Home />,
//   },
//   {
//     path: '/profile',
//     element: <ProfilePage />,
//   },
//   {
//     path: '/chat',
//     element: <ChatPage />,
//   },
//   {
//     path: '/matching',
//     element: <MatchingPage />,
//   },
// ]);

// function App() {
//   return (
//     <React.StrictMode> {/* React.StrictMode는 여기에 그대로 유지 */}
//       {/* ★★★ RouterProvider 사용 ★★★ */}
//       <RouterProvider router={router} />
//     </React.StrictMode>
//   );
// }

// export default App;

// import logo from './logo.svg';
import './App.css';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Context Providers
import { AuthProvider } from './contexts/authContext';
import { SocketProvider } from './contexts/socketContext';

// Pages and Components
import Home from './pages/Home';
import ProfilePage from './pages/ProfilePage';
import ChatPage from './pages/ChatPage';
import MatchingPage from './pages/MatchingPage';
import Inbox from './pages/Inbox';
import ProtectedRoute from './components/ProtectedRoute';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AdminPage from './adminPages/AdminPage';
import UserDetailPage from './adminPages/UserDetailPage';
import ReportPage from './adminPages/ReportPage';
import ReportDetailPage from './adminPages/ReportDetailPage';
import AdminLayout from './adminPages/AdminLayout'; // [추가]
import NoticeListPage from './pages/NoticeListPage'; // [추가]
import NoticeDetailPage from './pages/NoticeDetailPage'; // [추가]
import NoticeAdminPage from './adminPages/NoticeAdminPage';
import NoticeEditor from './adminPages/NoticeEditor';
import AIMatchingPage from './pages/AIMatchingPage';
import MainLayout from './components/MainLayout';
import SettingsPage from './pages/SettingsPage';
import MyInfoPage from './pages/MyInfoPage';
import FriendListPage from './pages/FriendListPage';
import AIFriendMatchingPage from './pages/AIFriendMatchingPage';
import SubscriptionPage from './pages/SubscriptionPage';
import MatchBridge from './pages/MatchBridge';

// 라우터 구조 변경
const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout/>,
    children: [
      {
        path: '/',
        element: <Home />, // 홈 페이지는 누구나 접근 가능
      },
      {
        path: '/match/:token', // 👈 [추가 2] 딥링크 환승역 경로 뚫어주기 (동적 파라미터 :token 사용)
        element: <MatchBridge />,
      },
      {
        path: '/notices', // [추가] 공지사항 경로
        element: <NoticeListPage />,
      },
      {
        path: '/notices/:noticeId', // [추가] 상세 공지사항 경로
        element: <NoticeDetailPage />,
      },
      {
        path: '/terms', // [추가] 이용약관 경로
        element: <TermsPage />,
      },
      {
        path: '/policy', // [추가] 개인정보처리방침 경로
        element: <PrivacyPolicyPage />,
      },
      {
        element: <ProtectedRoute />,
        children: [
          { path: '/friend-list', element: <FriendListPage />},
          { path: '/profile', element: <ProfilePage /> },
          { path: '/matching', element: <MatchingPage /> },
          { path: '/chat', element: <ChatPage /> },
          { path: '/inbox', element: <Inbox />},
          { path: '/recommendations', element: <AIMatchingPage/>},
          { path: '/ai-friend', element: <AIFriendMatchingPage/>},
          { path: '/settings', element: <SettingsPage/>},
          { path: '/settings/my-info', element: <MyInfoPage/>},
          { path: '/subscription', element: <SubscriptionPage/>},
          
          // [수정] 관리자 페이지 경로들을 AdminLayout의 자식으로 묶습니다.
          {
            path: '/admin',
            element: <AdminLayout />,
            children: [
              // { path: '', element: <AdminDashboard /> }, // 관리자 홈 (대시보드)
              { path: 'users', element: <AdminPage /> },
              { path: 'users/:userId', element: <UserDetailPage /> },
              { path: 'reports', element: <ReportPage /> },
              { path: 'reports/chatroom/:chatRoomId', element: <ReportDetailPage /> },
              { path: 'notices', element: <NoticeAdminPage /> },
              { path: 'notices/new', element: <NoticeEditor /> },      // 새 글 작성
              { path: 'notices/edit/:noticeId', element: <NoticeEditor /> }, // 글 수정
            ]
          }
        ]
      }
    ]
  }
]);

function App() {
  return (
    <React.StrictMode>
      <AuthProvider>
        <SocketProvider>
          <RouterProvider router={router} />
        </SocketProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}

export default App;